
import { TicketRunningIcon } from '@/components/icons/svg-icons';
import { VariantProps, cva } from 'class-variance-authority';


const teamDotVariants = cva('team-name__dot', {
	variants: {
		variant: {
			blue: 'team-name__dot--blue',
			red: 'team-name__dot--red',
			serve: 'team-name__dot--serve',
		}
	}
});

interface TeamDotProps extends React.ComponentPropsWithoutRef<'div'>, VariantProps<typeof teamDotVariants> {
	isActive?: boolean;
}

export const TopbarTeamDot = ({
	className,
	variant,
	isActive
}: TeamDotProps) => {
	return (
		<span
			className={teamDotVariants({ variant, className })}
			data-active={isActive ? true : null}
		>
			<TicketRunningIcon />
		</span>
	)
}